// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"dbf25091","963":"05bc0647"}[chunkId] + ".chunk.js";
};